import { URL_BASE } from "../../constants/url";
import { get, post, postFile } from "../../utils/fetch";

const formatResult = (result) =>
  result.code === 0
    ? { success: true, data: result.data }
    : { success: false, error: result.error };

export const getDesglose = async (id) => {
  const result = await get(`${URL_BASE}/api/DesgloseCabina/GetDesgloseByAsistenciaID/${id}`)
  return formatResult(result);
}

export const addDesglose = async ({file, ...body}) => {
  const formData = new FormData();

  Object.entries(body).forEach(([key, value]) => formData.append(key, value));

  if (file) {
    formData.append("file", file[0].originFileObj);
  }

  const result = await postFile(`${URL_BASE}/api/DesgloseCabina/AddDesglose`, formData)
  return formatResult(result);
}

export const deleteDesglose = async (id) => {
  const result = await post(`${URL_BASE}/api/DesgloseCabina/DeleteDesglose/${id}`)
  return formatResult(result);
}

export const editDesglose = async (body) => {
  const result = await post(`${URL_BASE}/api/DesgloseCabina/EditarDesglose`, body)
  return formatResult(result);
}
